import React from "react";
import { Grid, useMediaQuery, IconButton } from "@mui/material";
import ArrowCircleLeftIcon from "@mui/icons-material/ArrowCircleLeft";
import { makeStyles } from "@mui/styles";
import { Box } from "@mui/system";
import { RightContainer } from "../../components/RightContainer";
import WhiteInosio from "../../icons/whiteinosio.svg";
import randomquotes from "../../random_quotes.json";
import { ResidentpageState } from "./ResidentpageState";
import Notification from "./components/residentPage/Notification";
import SearchSpecialCode from "./components/residentPage/SearchSpecialCode";
import { useHistory } from "react-router-dom";
import { clearSearchingState } from "./sagas/invitations/invitationSlice";
import { useDispatch } from "react-redux";
import { clearValidateTokenError } from "../sagas/auth/authSlice";

const useStyles = makeStyles((theme) => ({
  rootContainer: {
    height: "100vh",
    width: "100%",
    display: "flex",
    flexDirection: "row",
    borderRadius: "24px",
  },
  rightContainer: {
    background: "#053742",
    width: "59%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    margin: "0 auto",
    height: "100%",
  },
  leftContainer: {
    borderRadius: "24px 0px 0px 24px",
    background: "#ffffff",
    width: "41%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    margin: "0 auto",
    position: "relative",
  },
  residentBox: {
    width: "340px !important",
    margin: "10px 0 !important",
  },
  residentBoxMobile: {
    width: "88vw",
    margin: "10px 0 !important",
  },
  brandContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    position: "relative",
  },
}));

export const SpecialCodePage = () => {
  const classes = useStyles();
  const matchesMobile = useMediaQuery("(max-width:380px)");
  const matches900 = useMediaQuery("(max-width:900px)");
  const matches1200 = useMediaQuery("(max-width:1200px)");
  const randomQuoteIndex = Math.floor(Math.random() * randomquotes.length);
  const loremIpsumPlaceholder: string = randomquotes[randomQuoteIndex].quote;

  const navigation = useHistory();
  const dispatch = useDispatch();
  const goToPrevPage = () => {
    navigation.push({ pathname: "/signup" });
    dispatch(clearValidateTokenError({}));
  };

  React.useEffect(() => {
    dispatch(clearSearchingState({}));
    dispatch(clearValidateTokenError({}));
  }, []);

  return (
    <div className={classes.rootContainer}>
      {/* Left part of page */}
      <Grid sx={{ flexDirection: "column", width: !matches900 ? "41%" : "100%" }} className={classes.leftContainer}>
        {/* Notification Component */}
        <Notification pageState={ResidentpageState.SearchSpecialCode} />

        {/* Inosio brand */}
        <Box className={classes.brandContainer} pb={3} sx={{ width: matchesMobile ? "88vw" : "340px" }}>
          {/* Go to prev page */}
          <IconButton edge="start" color="inherit" aria-label="go to prev" onClick={goToPrevPage} sx={{ position: "absolute", left: 0, top: "-8px" }}>
            <ArrowCircleLeftIcon sx={{ width: "30px", height: "30px", fill: "#39A2DB" }} />
          </IconButton>

          <img src={WhiteInosio} style={{ width: "78px", height: "78px", marginLeft: "0" }} alt="logo" />
        </Box>
        <Box className={`${matchesMobile ? classes.residentBoxMobile : classes.residentBox}`}>
          <SearchSpecialCode />
        </Box>
      </Grid>

      {/* Right part of page */}
      {!(matches900 && matches1200) ? (
        <Grid className={classes.rightContainer}>
          <RightContainer textPlaceholder={loremIpsumPlaceholder} />
        </Grid>
      ) : (
        <></>
      )}
    </div>
  );
};
